import { Accordion, AccordionDetails, AccordionSummary, Chip, Divider, Stack, Typography } from "@mui/material";
import { TCategorizedAgenda, TConfiguredAgendaItem } from "../../organisms/accept-invitation-form/type";
import { getAgendaStatusColor, getAgendaStatusText } from "../../organisms/accept-invitation-form/helper";
import AgendaDetails from "./AgendaDetails";
import {
  ExpandMore as ExpandMoreIcon
} from "@mui/icons-material";

const MobileAgendaAccordion: React.FC<{
  agenda: TConfiguredAgendaItem;
  index: number;
  isExpanded: boolean;
  onToggle: () => void;
  showArchived: boolean;
  peId: number;
  expertId: number;
  projectId: number;
  setPeAgendaData: React.Dispatch<React.SetStateAction<TCategorizedAgenda>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  handleNoSentAgendaExist: () => void;
  isAcceptInvitation: boolean
}> = ({
  agenda,
  index,
  isExpanded,
  onToggle,
  showArchived,
  peId,
  expertId,
  projectId,
  setPeAgendaData,
  setLoading,
  handleNoSentAgendaExist,
  isAcceptInvitation
}) => (
    <Accordion
      defaultExpanded
      expanded={isExpanded}
      onChange={(_, expanded) => expanded && onToggle()}
      sx={{
        mb: 1,
        borderRadius: '10px !important',
        border: '1px solid',
        borderColor: 'divider',
        '&:before': { display: 'none' },
        boxShadow: 'none'
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ '& .MuiAccordionSummary-content': { margin: '12px 0' } }}
      >
        <Stack direction="column" spacing={1} sx={{ width: '100%', pr: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography fontSize="14px" fontWeight={500} noWrap sx={{ flex: 1 }}>
              {agenda.title || "No Title Provided"}
            </Typography>
            <Chip
              label={getAgendaStatusText(agenda.status)}
              color={getAgendaStatusColor(agenda.status)}
              size="small"
              variant="outlined"
              sx={{ fontSize: '10px', height: '20px' }}
            />
          </Stack>
          <Typography variant="caption" color="text.secondary">
            {agenda.formattedAgenda?.length || 0} questions
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Divider sx={{ mb: 2 }} />
        <AgendaDetails
          agenda={agenda}
          isAcceptInvitation={isAcceptInvitation}
          showArchived={showArchived}
          peId={peId}
          expertId={expertId}
          projectId={projectId}
          setPeAgendaData={setPeAgendaData}
          handleNoSentAgendaExist={handleNoSentAgendaExist}
        />
      </AccordionDetails>
    </Accordion>
  );

export default MobileAgendaAccordion;